import * as React from 'react';

import classnames from 'classnames';

import styles from './price.module.css';

type Props = {
    price: string;
    strikethrough?: boolean;
    isBold?: boolean;
    color?: 'light' | 'medium' | 'dark' | 'green';
    hasMarketingFont?: boolean;
    size?: 'small' | 'normal' | 'large' | 'extraLarge';
    includeDollarSign?: boolean;
    isFlexEnd?: boolean;
    includePlus?: boolean;
};

export function Price(props: Props) {
    const {
        isBold = true,
        color = 'dark',
        size = 'normal',
        includeDollarSign = true,
        includePlus,
    } = props;

    const priceComponents = props.price.split('.');

    const styleNames = classnames({
        [styles.container]: true,
        [styles.strikethrough]: props.strikethrough,
        [styles.bold]: isBold,
        [styles.dark]: color === 'dark',
        [styles.medium]: color === 'medium',
        [styles.light]: color === 'light',
        [styles.green]: color === 'green',
        [styles.marketing]: props.hasMarketingFont,
        [styles.small]: size === 'small',
        [styles.large]: size === 'large',
        [styles['extra-large']]: size === 'extraLarge',
        [styles['flex-end']]: props.isFlexEnd,
    });

    return (
        <div className={styleNames}>
            <span>
                {includeDollarSign ? '$' : ''}
                {priceComponents[0]}
            </span>
            {includePlus
                ? '+'
                : priceComponents.length > 0 && (
                      <span className={styles.decimal}>{priceComponents[1]}</span>
                  )}
        </div>
    );
}
